import { render, staticRenderFns } from "./StatisticsFlawPanel.vue?vue&type=template&id=5c3ac627"
import script from "./StatisticsFlawPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsFlawPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports